import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'app/components/layout/Text.styled';
import Styled from 'app/features/couponCampaign/landing/components/Perks/Perks.styled';

const OneHourAfterJapanBroadcast = () => (
  <Styled.Perk data-t="one-hour-after-japan-broadcast-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="--colors-scooter">
      <path d="M20 3.333c9.205 0 16.667 7.462 16.667 16.667 0 9.205-7.462 16.667-16.667 16.667-9.205 0-16.667-7.462-16.667-16.667 0-9.205 7.462-16.667 16.667-16.667zm0 3.334c-7.364 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.333 13.333 13.333 7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333zm1.667 5v9.225l-5.742 3.828-1.85-2.773 4.258-2.84v-7.44h3.334z" />
    </Styled.PerkIcon>
    <Text as={Styled.PerkDescription} size="l">
      <FormattedMessage id="coupon_landing_one_hour_after_japan_broadcast_perk" />
    </Text>
  </Styled.Perk>
);

export default OneHourAfterJapanBroadcast;
